import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
import { restrictedAsset, wrapWithRestrictedAssetTooltip } from '../utils/fieldLevelPermissionsUtilsForQuickFilters';
import QuickFilterSelectBase from './QuickFilterSelectBase';
import QuickFilterTooltip from './QuickFilterTooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { DownCaratIcon } from 'foundations-assets';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';

// Hack: the foundation component Select and the UISelect use a 8px icon
// to prevent differnt looking quick filters we need to override the internal
// size of the icon
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const TrellisMigrateIconResizer = styled.div.withConfig({
  displayName: "QuickFilterSelect__TrellisMigrateIconResizer",
  componentId: "kysbs8-0"
})(["svg{width:8px !important;height:8px !important;}"]);
const QuickFilterSelect = ({
  buttonProperties,
  buttonText,
  condition,
  disableTruncation,
  isActive,
  isFirst,
  isOpen,
  popoverContent,
  onToggleOpen,
  onValueChange,
  width,
  property
}) => {
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const renderButtonContent = () => {
    const baseContent = /*#__PURE__*/_jsxs(_Fragment, {
      children: [isRestrictedField && restrictedAsset, buttonText]
    });
    if (disableTruncation) {
      const contentWithoutTruncation = /*#__PURE__*/_jsx("span", {
        children: baseContent
      });
      return isRestrictedField ? wrapWithRestrictedAssetTooltip(contentWithoutTruncation) : /*#__PURE__*/_jsx(QuickFilterTooltip, {
        condition: condition,
        property: property,
        children: contentWithoutTruncation
      });
    }
    const useTruncateStringTooltip = !isActive && !property.tooltip;
    const contentWithValue = /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(TruncateString, {
        maxWidth: buttonProperties.LABEL_MAX_WIDTH,
        tooltip: useTruncateStringTooltip && !isRestrictedField,
        useFlex: true,
        children: baseContent
      }), /*#__PURE__*/_jsx(View, {
        as: "span",
        marginInlineStart: "100",
        children: /*#__PURE__*/_jsx(TrellisMigrateIconResizer, {
          children: /*#__PURE__*/_jsx(DownCaratIcon, {
            color: "icon-core-subtle"
          })
        })
      })]
    });
    return isRestrictedField ? wrapWithRestrictedAssetTooltip(contentWithValue) : /*#__PURE__*/_jsx(QuickFilterTooltip, {
      condition: condition,
      disabled: useTruncateStringTooltip,
      property: property,
      children: contentWithValue
    });
  };
  return /*#__PURE__*/_jsx(Popover, {
    autoPlacement: false,
    closeOnOutsideClick: true,
    content: popoverContent,
    onClick: evt => evt.stopPropagation(),
    onOpenChange: onToggleOpen,
    open: isOpen,
    placement: isFirst ? 'bottom right' : 'bottom',
    inlineSize: width,
    children: /*#__PURE__*/_jsx(QuickFilterSelectBase, {
      button: /*#__PURE__*/_jsx(Button, {
        disabled: isRestrictedField || property.disabled,
        onClick: onToggleOpen,
        truncate: true,
        size: buttonProperties.BUTTON_SIZE,
        use: buttonProperties.BUTTON_USE,
        children: renderButtonContent()
      }),
      buttonHeight: buttonProperties.BUTTON_HEIGHT,
      isActive: isActive,
      onValueChange: onValueChange,
      propertyName: property.name
    })
  });
};
export default QuickFilterSelect;